<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col">
        <Topbar ref="con1" @inid="inid" v-if="typeControlPermission" />
        <span v-else v-text="'您沒有管理權限'"></span>
      </div>
    </div>
  </div>        
</template>
<script>
import { mapState } from "vuex";
import Topbar from "./uscontrol/Act_topbar.vue"


export default {
  name: 'Act_my',   
  components: {
    Topbar,
  },
  data() {
    return {
      data: [],
    };
  },
  computed: {
    ...mapState("account", ["status", "user"]),
    ...mapState("makeorg", ["defaultval"]),
      typeControlPermission() {
        const currentVal = this.$route.name;
        // 取得 acts_permissions 陣列，從 defaultval.permissions.acts_permissions
        const acts_permissions = this.defaultval?.permissions?.acts_permissions || [];
        // 找到 vals 為 Advancementoption 的主功能
        const adv = acts_permissions.find(item => item.vals === "Actmanagement");
        if (!adv) return null;
        // 在其 acts_detailpermission 裡找 vals 為 Type_control 的細項
        return adv.acts_detailpermission.find(d => d.vals === currentVal) || null;
      }    
  },
  mounted() {
  },
  methods: {
    inid(){
      this.$refs["con2"].inid()
    }
  },
  beforeRouteLeave(to, from, next) {
    if(to.name!=='Act_date'){
      window.sessionStorage.removeItem('queryTableState');
      window.sessionStorage.removeItem('queryNewTabIndex');
    }
    next();
  }, 

};
</script>